import { useMutation } from "@tanstack/react-query"
import {
  surveyTestEnd,
  surveyTestFill,
  surveyTestLanguage,
  surveyTestScreen,
  surveyTestStart,
  surveyTestSubmit,
} from "api/Repos/survey-test"
import { useAuthedAxios } from "hooks/core/useAuthedAxios"
import {
  SurveyFillRequest,
  SurveyLanguageRequest,
  SurveySessionRequest,
  SurveyStartRequest,
  SurveySubmitRequest,
} from "types/surveyTest.types"

/** The link test's server calls on its session. Every click is a command: nothing is cached or invalidated. */
export const useSurveyTest = (projectId: string, owner: string) => {
  const getAxios = useAuthedAxios()
  const start = useMutation({
    mutationFn: async (body: SurveyStartRequest) => surveyTestStart(await getAxios(), projectId, owner, body),
  })
  const screen = useMutation({
    mutationFn: async (body: SurveySessionRequest) => surveyTestScreen(await getAxios(), projectId, owner, body),
  })
  const submit = useMutation({
    mutationFn: async (body: SurveySubmitRequest) => surveyTestSubmit(await getAxios(), projectId, owner, body),
  })
  const fill = useMutation({
    mutationFn: async (body: SurveyFillRequest) => surveyTestFill(await getAxios(), projectId, owner, body),
  })
  const language = useMutation({
    mutationFn: async (body: SurveyLanguageRequest) => surveyTestLanguage(await getAxios(), projectId, owner, body),
  })
  const end = useMutation({
    mutationFn: async (body: SurveySessionRequest) => surveyTestEnd(await getAxios(), projectId, owner, body),
  })
  return { start, screen, submit, fill, language, end }
}
